import React from 'react';

const Img = ({ src, alt, ...props }: React.ComponentProps<'img'>) => (
	<img src={src} alt={alt} {...props} />
);

export default Img;
